import { cap } from "../goal/text";

/** What each of the agent's abilities is called on screen: "what it can do", in plain words, never its code name. */
const NAMES: Record<string, string> = {
  tracking_check: "Check tracking",
  conversion_upload: "Send results to ad platforms",
  email_verify: "Check email addresses",
  find_tool: "Find a data source",
  web_search: "Search the web",
  read_page: "Read a page",
  list_lessons: "Read lessons",
  save_plan: "Save the plan",
  ad_results: "Read ad results",
  results_by_ad: "Read results per ad",
  goal_state: "Read where the goal stands",
  propose_action: "Ask before acting",
  find_targeting: "Look up who Meta can reach",
  estimate_reach: "Estimate how many people Meta can reach",
  confirm_identity: "Confirm the business",
  save_product: "Save the profile",
  launch_ad: "Launch an ad",
  list_ad_accounts: "Find ad accounts",
  generate_ad_image: "Make ad pictures",
  generate_ad_video: "Make ad videos",
  call_catalog_tool: "Use data sources",
  linkedin_search_posts: "Search LinkedIn posts",
  linkedin_profile: "Read LinkedIn profiles",
  modelmatch_lookup: "Look up sales records (Model Match)",
  save_lead: "Save people",
  list_leads: "List people",
  email_step: "Send emails (Smartlead)",
  email_replies: "Read replies (Smartlead)",
  read: "Read files",
  save_lesson: "Save lessons",
  update_ad_budget: "Change ad budgets",
  cut_clip: "Cut clips from your footage",
};

export const toolName = (t: string) => NAMES[t] ?? cap(t.replace(/_/g, " "));
